export const i18n = {};

i18n.se = {
    loginview: {
        h1: "Logga in för att se din UX-översikt",
        emailfield: {
            label: " E-postadress",
            placeholder: "email@example.com"
        },
        passwordfield: {
            label: "Lösenord",
            placeholder: "******"
        },
        loginbutton: {
            text: "Logga in"
        }
    },
    dashboardview: {
    }
}

i18n.en = {

}